import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import PageLayout from '../components/PageLayout';
import Lightbox from '../components/Lightbox';
import './Immigration.css';

const MRKArtGallery = () => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState({ src: '', alt: '' });

  const galleryImages = [
    { src: '/images/art-gallery/1.jpg', alt: 'Contemporary Art Piece 1' },
    { src: '/images/art-gallery/2.jpg', alt: 'Contemporary Art Piece 2' },
    { src: '/images/art-gallery/3.jpg', alt: 'Contemporary Art Piece 3' },
    { src: '/images/art-gallery/4.jpg', alt: 'Contemporary Art Piece 4' },
    { src: '/images/art-gallery/5.jpg', alt: 'Contemporary Art Piece 5' },
    { src: '/images/art-gallery/6.jpg', alt: 'Contemporary Art Piece 6' },
    { src: '/images/art-gallery/7.jpg', alt: 'Contemporary Art Piece 7' },
    { src: '/images/art-gallery/8.jpg', alt: 'Contemporary Art Piece 8' },
    { src: '/images/art-gallery/9.jpg', alt: 'Contemporary Art Piece 9' },
    { src: '/images/art-gallery/10.jpg', alt: 'Contemporary Art Piece 10' },
    { src: '/images/art-gallery/11.jpg', alt: 'Contemporary Art Piece 11' },
    { src: '/images/art-gallery/12.jpg', alt: 'Contemporary Art Piece 12' },
    { src: '/images/art-gallery/13.jpg', alt: 'Contemporary Art Piece 13' },
    { src: '/images/art-gallery/14.jpg', alt: 'Contemporary Art Piece 14' },
    { src: '/images/art-gallery/15.jpg', alt: 'Contemporary Art Piece 15' },
    { src: '/images/art-gallery/16.jpg', alt: 'Contemporary Art Piece 16' },
    { src: '/images/art-gallery/17.jpg', alt: 'Contemporary Art Piece 17' },
    { src: '/images/art-gallery/18.png', alt: 'Contemporary Art Piece 18' },
    { src: '/images/art-gallery/19.png', alt: 'Contemporary Art Piece 19' }
  ];

  const openLightbox = (src, alt) => {
    setLightboxImage({ src, alt });
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImage({ src: '', alt: '' });
  };

  return (
    <PageLayout 
      title="MRK Contemporary Art Gallery" 
      subtitle="Celebrating pioneering Emirati artists and Eurabian artworks with Arabic and Islamic influence by renowned international artists, featuring landscape abstract expressionism and masterpieces from Americas, Europe and Asia."
    >
      <section className="immigration-section">
        <div className="container">
          <div className="immigration-intro">
            <h2>Contemporary Art Excellence</h2>
            <p>
              MRK Contemporary Art gallery celebrates pioneering Emirati artists and international masterpieces with Arabic and Islamic influence. Founded by accomplished artist Meena Kamal, who is credited for creating a new genre in landscape abstract expressionism.
            </p>
          </div>
          
          <div className="tab-content">
            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Emirati Artists & Cultural Heritage</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We showcase the journey of legendary Emirati artists and talented child prodigies in Dubai, celebrating the rich cultural heritage and artistic evolution of the UAE through contemporary expressions and traditional influences.
                  </p>
                  
                  <div className="info-section">
                    <h4>Pioneering Emirati Art</h4>
                    <ul>
                      <li>Legendary Emirati artists showcase and representation</li>
                      <li>Cultural heritage preservation through contemporary art</li>
                      <li>UAE artistic evolution documentation and celebration</li>
                      <li>Traditional Arabic and Islamic artistic influences</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Young Talents Development</h4>
                    <ul>
                      <li>Talented child prodigies nurturing and mentorship</li>
                      <li>Emerging and mid-career artists representation</li>
                      <li>Platform for artistic protégés across mediums</li>
                      <li>Digital art platform integration and support</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/world_of_art.png" 
                    alt="Emirati Artists Cultural Heritage" 
                    onClick={() => openLightbox('/images/world_of_art.png', 'Emirati Artists Cultural Heritage')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>International Masterpieces & Collections</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    Our gallery features masterpieces by renowned international artists from Americas, Europe and Asia, including portraits of Rulers by American artist Paul Morin and contemporary charcoal expressions by Korean artist Zin Lim.
                  </p>
                  
                  <div className="info-section">
                    <h4>International Artists Portfolio</h4>
                    <ul>
                      <li>Renowned American artist Paul Morin portraits collection</li>
                      <li>Korean artist Zin Lim contemporary charcoal works</li>
                      <li>International artists from Americas, Europe and Asia</li>
                      <li>Eurabian artworks with Arabic and Islamic influence</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Landscape Abstract Expressionism</h4>
                    <ul>
                      <li>Meena Kamal's pioneering landscape abstract expressionism</li>
                      <li>New genre recognition by international art critics</li>
                      <li>Contemporary art innovation and breakthrough techniques</li>
                      <li>Museum-quality works and exhibition pieces</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="https://images.unsplash.com/photo-1541961017774-22349e4a1262?q=80&w=2058&auto=format&fit=crop&ixlib=rb-4.1.0" 
                    alt="International Masterpieces" 
                    onClick={() => openLightbox('https://images.unsplash.com/photo-1541961017774-22349e4a1262?q=80&w=2058&auto=format&fit=crop&ixlib=rb-4.1.0', 'International Masterpieces')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>

            <div className="immigration-service-card">
              <div className="service-header">
                <h3>Art Advisory & Collection Services</h3>
              </div>
              <div className="service-content">
                <div className="service-text">
                  <p>
                    We offer comprehensive art advisory services with over twenty years of experience, focusing on contemporary art and secondary market opportunities in collaboration with affluent art consultant James Bacchi from California, USA.
                  </p>
                  
                  <div className="info-section">
                    <h4>Expert Advisory Services</h4>
                    <ul>
                      <li>Art acquisition consultation and guidance</li>
                      <li>Private collections sale and evaluation</li>
                      <li>Over twenty years of artworld experience</li>
                      <li>Collaboration with California-based advisor James Bacchi</li>
                    </ul>
                  </div>
                  
                  <div className="info-section">
                    <h4>Exclusive Viewing Experience</h4>
                    <ul>
                      <li>Private viewing appointments and personalized guidance</li>
                      <li>Special viewing experiences for collectors</li>
                      <li>Expert critique and artwork interpretation services</li>
                      <li>Contemporary art and secondary market focus</li>
                    </ul>
                  </div>
                </div>
                <div className="service-image">
                  <img 
                    src="/images/MohammedAlMor.png" 
                    alt="Art Advisory Services" 
                    onClick={() => openLightbox('/images/MohammedAlMor.png', 'Art Advisory Services')}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="gallery-showcase-section" style={{marginBottom: '40px'}}>
            <h3 style={{fontSize: '1.8rem', fontWeight: '700', marginBottom: '24px', color: '#1a1a1a', textAlign: 'center'}}>
              Art Gallery Collection
            </h3>
            
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={24}
              slidesPerView={3}
              loop={true}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              navigation={{
                nextEl: '.gallery-swiper-button-next',
                prevEl: '.gallery-swiper-button-prev',
              }}
              pagination={{
                el: '.gallery-swiper-pagination',
                clickable: true,
                dynamicBullets: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
              }}
              className="gallery-swiper"
              style={{marginBottom: '32px'}}
            >
              {galleryImages.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="gallery-card">
                    <div className="gallery-image-container">
                      <img 
                        src={image.src} 
                        alt={image.alt}
                        onClick={() => openLightbox(image.src, image.alt)}
                        style={{ 
                          cursor: 'pointer',
                          width: '100%',
                          height: '300px',
                          objectFit: 'cover',
                          borderRadius: '12px',
                          transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'scale(1.05)';
                          e.target.style.boxShadow = '0 10px 25px rgba(0,0,0,0.2)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'scale(1)';
                          e.target.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                        }}
                      />
                    </div>
                    <h4 style={{
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      marginTop: '12px',
                      marginBottom: '8px',
                      color: '#1a1a1a'
                    }}>
                      {image.alt}
                    </h4>
                    <p style={{
                      fontSize: '0.9rem',
                      color: '#666',
                      margin: '0',
                      lineHeight: '1.4'
                    }}>
                      Click to view in full size
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="gallery-swiper-navigation">
              <div className="gallery-swiper-pagination"></div>
            </div>
          </div>

          <div className="immigration-service-card">
            <div className="service-header">
              <h3>Why Choose MRK Contemporary Art Gallery?</h3>
            </div>
            <div className="service-content">
              <div className="service-text">
                <p style={{fontSize: '1.1rem', marginBottom: '30px'}}>
                  MRK Contemporary's mission focuses on a multitude of levels, from spotting and representing young nurturing talents to matured and legendary artists, whose works grace the walls of art museums worldwide.
                </p>
                
                <div className="info-section">
                  <h4>Pioneer in Art Innovation</h4>
                  <p>First gallery to offer platform for artistic protégés across different mediums including digital, with Meena Kamal's groundbreaking landscape abstract expressionism.</p>
                </div>
                
                <div className="info-section">
                  <h4>Cultural Bridge</h4>
                  <p>Celebrating Eurabian artworks with Arabic and Islamic influence while showcasing international masterpieces from renowned artists across continents.</p>
                </div>
                
                <div className="info-section">
                  <h4>Comprehensive Expertise</h4>
                  <p>Over twenty years of artworld experience with expert advisory services for art acquisition and private collection management.</p>
                </div>
                
                <div className="info-section">
                  <h4>Exclusive Access</h4>
                  <p>Private viewing experiences and personalized guidance for collectors with direct access to emerging and legendary artists.</p>
                </div>
                
                <div style={{marginTop: '32px', padding: '24px', background: 'rgba(0,0,0,0.05)', borderRadius: '12px'}}>
                  <p style={{margin: '0', fontSize: '1rem', lineHeight: '1.6', fontStyle: 'italic'}}>
                    For private viewing appointments, art critique, or interpretation services, contact us at info@mrkcontemporaryart.com. We offer special viewing experiences and personalized guidance for art collection development.
                  </p>
                </div>
              </div>
              <div className="service-image">
                <img 
                  src="/images/why_chose_us.png" 
                  alt="Art Gallery Excellence" 
                  onClick={() => openLightbox('/images/why_chose_us.png', 'Art Gallery Excellence')}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            </div>
          </div>
          
          <div className="immigration-page-cta-section">
            <h3>Experience Contemporary Art Excellence</h3>
            <p>Ready to explore masterpieces and build your art collection? Schedule a private viewing with our gallery specialists.</p>
            <a href="/contact" className="btn immigration-btn-primary">Schedule Private Viewing</a>
          </div>
        </div>
      </section>
      
      <Lightbox 
        isOpen={lightboxOpen}
        imageSrc={lightboxImage.src}
        imageAlt={lightboxImage.alt}
        onClose={closeLightbox}
      />
    </PageLayout>
  );
};

export default MRKArtGallery;